import { Component, OnInit } from "@angular/core";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-home-services",
  templateUrl: "./services.component.html",
  styleUrls: ["./services.component.scss"]
})
export class ServicesHomeComponent implements OnInit {
  lang: string;
  constructor(private base: BaseService) {}

  ngOnInit() {
    this.lang = this.base.getLang();
  }

  ngAfterContentChecked(): void {
    this.lang = this.base.getLang();
  }
}
